"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_property_decorator_1 = require("vue-property-decorator");
const vuex_1 = require("vuex");
const vehicle_card_vue_1 = tslib_1.__importDefault(require("@/components/vehicle-card/vehicle-card.vue"));
const cleopatra_wrapper_vue_1 = tslib_1.__importDefault(require("@/components/cleopatra-wrapper/cleopatra-wrapper.vue"));
const utils_1 = require("@/utils");
const vehicle_selector_body_vue_1 = tslib_1.__importDefault(require("@/components/vehicle-selector-body/vehicle-selector-body.vue"));
const modules_1 = require("@/store/modules");
const legal_banner_vue_1 = tslib_1.__importDefault(require("@/components/legal-banner/legal-banner.vue"));
const footnote_vue_1 = tslib_1.__importDefault(require("@/components/footnote/footnote.vue"));
const vehicle_tile_footer_vue_1 = tslib_1.__importDefault(require("@/components/vehicle-tile-footer/vehicle-tile-footer.vue"));
const modal_vue_1 = tslib_1.__importDefault(require("@/components/modal/modal.vue"));
const aem_form_wrapper_vue_1 = tslib_1.__importDefault(require("@/components/aem-form-wrapper/aem-form-wrapper.vue"));
const toggle_vue_1 = tslib_1.__importDefault(require("@/components/toggle/toggle.vue"));
const core_1 = require("@workbench/core");
const myMediaQueryService = new core_1.MediaQueryService(window);
let VehicleTile = class VehicleTile extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.isContactFormVisible = false;
        this.currentMQ = myMediaQueryService.getCurrentMediaQuery();
    }
    onResize(e) {
        this.currentMQ = e.detail.current;
    }
    get shouldDisplayMobile() {
        return this.currentMQ === 'mq1' || this.currentMQ === 'mq2' || this.currentMQ === 'mq3';
    }
    onWindowResize() {
        // to observe media query changes across time
        window.addEventListener('wbresize', this.onResize);
        // pass in `true` if you are interested in the media query in the moment of calling the function
        myMediaQueryService.observe(true);
    }
    mounted() {
        this.onWindowResize();
    }
    beforeDestroy() {
        window.removeEventListener('wbresize', this.onResize);
        myMediaQueryService.disconnect();
    }
    get shouldDisplayLegalBanner() {
        return this.legalBannerImageUrl || this.legalBannerText;
    }
    get shouldDisplayDisclaimers() {
        return !!this.disclaimers;
    }
    toggleContactFormModal() {
        this.isContactFormVisible = !this.isContactFormVisible;
    }
    handleButtonClick(buttonId) {
        if (buttonId === utils_1.CONTACT_FORM_BUTTON_ID || buttonId === utils_1.OCAPI_BUTTON_TYPE.CAR_CONFIGURATOR) {
            const widget = this.$refs.cleopatraWidget;
            widget.generateFinanceCode(buttonId);
        }
    }
};
VehicleTile = tslib_1.__decorate([
    (0, vue_property_decorator_1.Component)({
        name: 'VehicleTile',
        components: {
            Footnote: footnote_vue_1.default,
            LegalBanner: legal_banner_vue_1.default,
            AemFormWrapper: aem_form_wrapper_vue_1.default,
            Modal: modal_vue_1.default,
            VehicleTileFooter: vehicle_tile_footer_vue_1.default,
            VehicleSelectorBody: vehicle_selector_body_vue_1.default,
            CleopatraWrapper: cleopatra_wrapper_vue_1.default,
            VehicleCard: vehicle_card_vue_1.default,
            Toggle: toggle_vue_1.default,
        },
        computed: Object.assign(Object.assign({}, (0, vuex_1.mapGetters)(modules_1.MODULES.VEHICLE_SELECTOR, ['vehicleSelectorIsVisible'])), (0, vuex_1.mapGetters)([
            'appStatus',
            'title',
            'legalBannerImageUrl',
            'legalBannerText',
            'disclaimers',
            'displayCustomerTypeToggle',
        ])),
        data: () => {
            return {
                APP_STATUS: utils_1.APP_STATUS,
            };
        },
    })
], VehicleTile);
exports.default = VehicleTile;
